var map = {
	"./avatarNum.png": 42442,
	"./avatarbg.png": 176857,
	"./comb2.png": 373576,
	"./comb3.png": 367441,
	"./comb5.png": 953191,
	"./combo5.png": 414116,
	"./mainbg-guid.png": 847847,
	"./mainbg.png": 826389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 343518;